export enum ReportStatus {
  Active = 1,
  Disabled = 2,
  ComingSoon = 3
}

